module.exports = __webpack_public_path__ + "img/logo-symbol.908463a2.svg";